import { useState } from "react";
import { ConfirmModal } from "../../ui/components/modal/ConfirmModal";

export function useConfirmModal() {
  const [modalProps, setModalProps] = useState<{
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
  }>({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: () => {},
  });

  function showModal(title: string, message: string, onConfirm: () => void) {
    setModalProps({ isOpen: true, title, message, onConfirm });
  }

  function closeModal() {
    setModalProps((prev) => ({ ...prev, isOpen: false }));
  }

  function ConfirmModalComponent() {
    return (
      <ConfirmModal
        isOpen={modalProps.isOpen}
        title={modalProps.title}
        message={modalProps.message}
        onConfirm={() => {
          modalProps.onConfirm();
          closeModal();
        }}
        onClose={closeModal}
      />
    );
  }

  return { showModal, ConfirmModalComponent };
}
